/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


if(window.themeVariables.settings.showthememodeoptions){
  var toggle = document.querySelectorAll(".theme-mode_toggle-item");

  if(localStorage.getItem('theme-mode')){
    var storedTheme =  localStorage.getItem('theme-mode');  
    document.documentElement.setAttribute('theme-mode', storedTheme)
  }else{
    var storedTheme =  document.documentElement.getAttribute("theme-mode");  
  }      
  
  for (const button of toggle) {
    button.addEventListener('click', function(event) {
      var currentTheme = document.documentElement.getAttribute("theme-mode");
      var targetTheme = "light";
      if (currentTheme === "light") {
          targetTheme = "dark";
      }
      document.documentElement.setAttribute('theme-mode', targetTheme)
      localStorage.setItem('theme-mode', targetTheme);  
    })
  }  
}else{
  localStorage.removeItem('theme-mode');
}


if($('body').hasClass('template--collection')){
  console.log('test');
  if (window.matchMedia('(max-width: 740px)').matches){
    // INFINITE COLLECTION
    var pInfScrLoading = false;
    var pInfScrDelay = 100;
    
    function pInfScrExecute() {
      if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
        var loadingImage;
        pInfScrNode = $('.product-list__inner.grid_view_custom').find('.more');	        
        // removeing this condition && pInfScrNode.css('display') != 'none'
        if(!pInfScrLoading && pInfScrNode.length > 0) {
          pInfScrURL = $('.product-list__inner.grid_view_custom').find('.more a').attr("href");
          $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/0028/9806/7554/files/Spinner-1s-200px.gif?v=1692351513" class="loading" />');
          $.ajax({
            type: 'GET',
            url: pInfScrURL,
            beforeSend: function() {
              pInfScrLoading = true;
              loadingImage = pInfScrNode.clone().empty().append('');
              loadingImage.insertAfter(pInfScrNode);
              pInfScrNode.hide();
              
              console.log('loading...');
            },
            success: function(data) {
              // remove loading feedback
              pInfScrNode.next().remove();
              var filteredData = $(data).find(".product-list__inner");
              // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
              $('.product-list__inner.grid_view_custom').find('.more').before(filteredData.html());
              if(filteredData.find('.more').length > 0){
                $('.product-list__inner.grid_view_custom').find('.more').html(filteredData.find('.more').html());
              }else{
                $('.product-list__inner.grid_view_custom').find('.more').remove();
              }
              
              
              loadingImage.remove();	              
              $('.product-list').find('.loading').remove();
              pInfScrLoading = false;
              document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
            },
            dataType: "html"
          });
        }
      }
    }
    $(document).ready(function () {
      $(window).scroll(function(){
        $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
        // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
        if( $('product-list.product-facet__product-list').height() - 400 < $(document).scrollTop()) {
          pInfScrDelay = 20;
        }
      });
    });
  }
}

$(document).ready(function() {

  if(window.location.hash === '#opencartdrawer') {
    document.getElementById('mini-cart').open = true;
    history.pushState("", document.title, window.location.pathname + window.location.search);
  }

  $('body').on('click','.get_app_section .pop_close_button', function(){
    $('#get_app_section').slideUp();
  });

  formatMoney = window.utils.formatMoney;
  
  const va_possp = new URLSearchParams(window.location.search);
  if(va_possp.has('va_pos')){
    $('.product .product__info .product-form [action="/cart/add"]').append('<input type="hidden" name="properties[_visearch_clicked]" value="true">').append('<input type="hidden" name="properties[_vi_vis]" value="'+va_possp.get('va_vis')+'">');
  }

  // CUSTOM formatCurrency
  const formatCurrency = (number, symbol = '₹') => {
    const formattedNumber = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `${symbol}${formattedNumber}`;
  };  

  document.addEventListener('cart:updated', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    console.log(cart);
    var ids = $('#mini-cart').attr('data-claimitms');
    var minval = parseInt($('#mini-cart').attr('data-pricelimit'));
    var totalreqprice = 0;
    $(cart['items']).each(function(i,e){
      if(ids.indexOf(e.id) > -1){        
        totalreqprice += e.final_line_price;
      }
    });
    var ctp = cart['total_price'] - totalreqprice;
    if(ctp < minval){        
      var cnttt = 0;
      var updateData = {};        
      $(cart['items']).each(function(i,e){
        if(ids.indexOf(e.id) > -1){
          updateData[e.id] = 0;
          cnttt++;
        }
      });
      console.log('jijiji');
      if(cnttt > 0){
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updateData
          },
          dataType: 'json',
          async: true,
          error: function (jqXHR, textStatus, errorThrown) {
            console.log('error')            
          },
          success: function(data) {   
            console.log('success')
            $.getJSON('/cart.js', function(cart){
              document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cart
                }
              }));
            });                
          }
          
        }); 
      }          
    }
  });

  if ($('body').hasClass('template--product') && $('body').attr("data-pid") != '') {

    function workcontent(data, productJsonselector){
      var cnt = 0;
      $(data).each(function(i,result){
        var mainhtml = '';
        var product = result;
        
        if(product.available){
          cnt++;
          var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
          mainhtml += `<div class="maincontent_wp"><product-item class="product-item" data-pid="${product.id}"><div class="product-item__image-wrapper">`;
          var savinglabl = '';
          if (!product.available) {
            savinglabl += `<span class="label label--subdued sold_out">${window.themeVariables.strings.collectionSoldOut}</span>`;
          } else if (parseInt(product.variants[0].price) < parseInt(product.variants[0].compare_at_price)) {
            let savings = "";
            if (window.themeVariables.settings.discountMode === "percentage") {
              savings = `${Math.round((parseInt(product.variants[0].compare_at_price) - parseInt(product.variants[0].price)) * 100 / parseInt(product.variants[0].compare_at_price))}%`;
            } else {
              savings = formatMoney(parseInt(product.variants[0].compare_at_price) - parseInt(product.variants[0].price));
            }
            savinglabl += `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace("@savings@", savings)}</span>`;
          }
          if(savinglabl != ''){
            mainhtml += `<div class="product-item__label-list label-list top">${savinglabl}</div>`;
          }              
            mainhtml += `<div data-instant class="product-item__media_slider">
              <a href="/products/${product.handle}"> 
                <img src="${product.images[0].src}" loading="lazy" width="${product.images[0].width}" height="${product.images[0].height}" class="product-item-image" alt="${product.title}">
              </a>                  
            </div>
            
            <div class="product-item__quick-form hidden-phone">
              <button is="toggle-button" loader aria-controls="product-${product.id}-drawer" aria-expanded="false" class="button button--primary button--text button--full hidden-touch hidden-phone">${window.themeVariables.strings.quick_view}</button>
              <button is="toggle-button" aria-controls="product-${product.id}-drawer" aria-expanded="false" class="product-item__quick-buy-button hidden-no-touch hidden-pocket">
                <span class="visually-hidden">${window.themeVariables.strings.quick_view}</span>
                ${window.themeVariables.settings.quickviewicon}
              </button>
    
              <button is="toggle-button" aria-controls="product-${product.id}-popover" aria-expanded="false" class="product-item__quick-buy-button hidden-tablet-and-up">
                <span class="visually-hidden">${window.themeVariables.strings.quick_view}</span>
                ${window.themeVariables.settings.quickviewicon}
              </button>
            </div>
    
            <quick-buy-popover id="product-${product.id}-popover" href="/products/${product.handle}?view=quick-buy-popover" class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>
            <quick-buy-drawer id="product-${product.id}-drawer" href="/products/${product.handle}?view=quick-buy-drawer" class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>
          </div>
        
          <div class="product-item__info">
            <div class="product-item-meta">
                <a href="/products/${product.handle}" data-instant class="product-item-meta__title">${product.title}</a>
                <div class="product-item-meta__price-list-container">
                  <div class="price-list price-list--centered">`;
                     if (parseInt(product.variants[0].price) < parseInt(product.variants[0].compare_at_price)) {
                        mainhtml += `<span class="price price--highlight"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatCurrency(Math.floor(parseInt(product.variants[0].price)))}</span>`;
                        mainhtml += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatCurrency(Math.floor(parseInt(product.variants[0].compare_at_price)))}</span>`;
                      } else {
                        mainhtml += `<span class="price ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatCurrency(Math.floor(parseInt(product.variants[0].price)))}</span>`;
                      }                        
                  mainhtml += `</div>
                </div>
            </div>
          </div>
          
        </product-item></div>`;
        $(productJsonselector).find('.app_product_slider').append(mainhtml);
        }
         if(data.length - 1 == i && cnt > 0){
           $(productJsonselector).closest('.shopify-section').addClass('hasitems');
            $(productJsonselector).find('.app_product_slider').slick({
              dots: false,
              arrows: true,
              autoplay: false,
              autoplaySpeed: 2000,
              speed: 1000,
              slidesToShow: 4,
              slidesToScroll: 2,
              touchThreshold: 100, 
              infinite: false,
              speed: 300,
              prevArrow: '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 14 14"><path d="M9.000015,2.5 C9.24547489,2.5 9.44961807,2.67688865 9.49194703,2.91013913 L9.5,3.000015 L9.49975995,10.999775 C9.49975259,11.2452244 9.32288575,11.4493626 9.08964671,11.4917022 L8.99977496,11.49976 L1.000015,11.5 C0.723872629,11.5 0.5,11.2761574 0.5,11.000015 C0.5,10.7545551 0.676861669,10.5504013 0.910109606,10.5080584 L0.999984997,10.5 L8.499,10.499 L8.5,2.999985 C8.5,2.75452511 8.67688865,2.55038193 8.91013913,2.50805297 L9.000015,2.5 Z" transform="rotate(-45 5 7)"></path></svg></button>',
              nextArrow: '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" fill="currentColor" viewBox="0 0 14 14"><path d="M9.000015,2.5 C9.24547489,2.5 9.44961807,2.67688865 9.49194703,2.91013913 L9.5,3.000015 L9.49975995,10.999775 C9.49975259,11.2452244 9.32288575,11.4493626 9.08964671,11.4917022 L8.99977496,11.49976 L1.000015,11.5 C0.723872629,11.5 0.5,11.2761574 0.5,11.000015 C0.5,10.7545551 0.676861669,10.5504013 0.910109606,10.5080584 L0.999984997,10.5 L8.499,10.499 L8.5,2.999985 C8.5,2.75452511 8.67688865,2.55038193 8.91013913,2.50805297 L9.000015,2.5 Z" transform="rotate(-45 5 7)"></path></svg></button>',
              responsive: [
                {
                  breakpoint: 999,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                }
              ]
            });                
          if(cnt == 0)  {
            $(productJsonselector).remove();   
          }                 
        }else{
           $(productJsonselector).closest('.shopify-section').removeClass('hasitems');
        }    
         
      }); 
    }
    
    async function getotp(){     
      let response = await fetch('https://asia-south1-plasma-renderer-442106-m5.cloudfunctions.net/RF_CF_prod_freakins', {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
            "Content-Type": "application/json",
            "x-api-key": "f0382ceaef963633ea6dc8856a1f4448"
        },
        body: JSON.stringify({
          "product_id": `${$('body').attr("data-pid")}`
        }), // Convert
      });
      const data = await response.json();
      return data;
    }
    getotp().then(data => {
      if(data.similar_product.length > 0){
        if($('[data-section="similar_view_products"]').length > 0){
          workcontent(data.similar_product, '[data-section="similar_view_products"]');  
        }        
      }else{
        $('[data-section="similar_view_products"]').closest('.shopify-section').removeClass('hasitems');
      }  
      if(data.pair_it_with_product.length > 0){
        if($('[data-section="pair_it_with_product"]').length > 0){        
          workcontent(data.pair_it_with_product, '[data-section="pair_it_with_product"]');
        }
      }else{
        $('[data-section="pair_it_with_product"]').closest('.shopify-section').removeClass('hasitems');
      }  
      if(data.shop_the_look_product.length > 0){
        if($('[data-section="shop_the_look_product"]').length > 0){        
          workcontent(data.shop_the_look_product, '[data-section="shop_the_look_product"]');
        }
      }else{
        $('[data-section="shop_the_look_product"]').closest('.shopify-section').removeClass('hasitems');
      }  
    });
  }
  
  $('body').on('click', '.custom_popup .recommandation_tabbing .tab_label', function(){
    $(this).closest('.recommandation_tabbing').find('.tab_label').removeClass('active');
    $(this).addClass('active');
    $(this).closest('.content_wp').find('.widget_items .tab_content').hide();
    $(this).closest('.content_wp').find('.widget_items .tab_content[data-tab="'+$(this).attr('data-tablabel')+'"]').show();
    $(this).closest('.content_wp').find('.widget_items .tab_content[data-tab="'+$(this).attr('data-tablabel')+'"] .app_product_slider').slick('refresh');
  });

  $('body').on('click','.grid_view_selector .view_wp', function(){
    $('.product-list__inner.grid_view_custom').attr('data-gridview',$(this).attr('data-gridview'));
    $(this).closest('.grid_view_selector').find('.view_wp').removeClass('active');
    $(this).addClass('active');
  });

  $('body').on('click','.footer .footer__item-title', function(){
     $(this).siblings('.footer__item-content').slideToggle();    
  });

  $('body').on('click','.search_widget_popup #search_proceed_btn', function(){    
    const fileInput = document.getElementById('file-upload');
    console.log(fileInput.value)
    const file = fileInput.files[0];
    console.log(file)
    if (!file) {
      alert('Please select an image to upload.');
      return;
    }
    var _this = this;
    _this.setAttribute("disabled", "disabled");
    _this.setAttribute("aria-busy", "true");
    
    const reader = new FileReader();
    reader.onloadend = function() {
      const base64Image = reader.result.split(',')[1]; // Extract the base64 part
      // console.log(base64Image); // Do something with the base64 encoded image
      const payload = {
        image: base64Image
      };
      async function getotp(){     
        let response = await fetch('https://image-search-freakins-service-158183727916.asia-south1.run.app/process-image', {
          method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
          headers : {
              "Content-Type": "application/json",
              "x-api-key": "gbZsSJr3by-7zSUwSfnI_9QaA4DcdJla"
          },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        return data;
      }
      getotp().then(data => {
        console.log(data)  
        var markups = ``;
        $(data.frontend_output_boxes).each(function(fob,foe){
          markups += `<span class="itembox_marker" style="inset: ${foe.top}% ${foe.right}% ${foe.bottom}% ${foe.left}%;"></span>`;
        });
        var centerpoints = ``;
        $(data.frontend_centre_points).each(function(fob,foe){
          centerpoints += `<a href="javascript:void(0)" data-pointindex="${fob}" class="centermarker" style="top: ${foe.top}%;left: ${foe.left}%;"><p is="toggle-button" class="shop-the-look__dot tap-area"></p></a>`;
        });
        var resulthtml = `<div class="result_main_image">
          <p class="dot_note">Click the dots to show a results for that item</p>
          <div class="image-preview">
            <img id="selected-image" src="${reader.result}" alt="Selected Image" />
            ${markups}${centerpoints}
          </div>          
          <a href="javascript:void(0)" class="button button--primary new-customsearch">New search</a>
        </div>`;
        var itemresults = ``;
        $(data.similar_product_info).each(function(ind,e){
          var itemsparts = ``;
          console.log(e);
          $(e).each(function(i,f){
            var product = f;              
            if(product.available){
              // cnt++;                
              var singleitem = `<div class="maincontent_wp"><product-item class="product-item" data-pid="${product.id}"><div class="product-item__image-wrapper">`;
              var savinglabl = '';
              if (!product.available) {
                savinglabl += `<span class="label label--subdued sold_out">${window.themeVariables.strings.collectionSoldOut}</span>`;
              } else if (parseInt(product.variants[0].price) < parseInt(product.variants[0].compare_at_price)) {
                let savings = "";
                if (window.themeVariables.settings.discountMode === "percentage") {
                  savings = `${Math.round((parseInt(product.variants[0].compare_at_price) - parseInt(product.variants[0].price)) * 100 / parseInt(product.variants[0].compare_at_price))}%`;
                } else {
                  savings = formatMoney(parseInt(product.variants[0].compare_at_price) - parseInt(product.variants[0].price));
                }
                savinglabl += `<span class="label label--highlight">${window.themeVariables.strings.collectionDiscount.replace("@savings@", savings)}</span>`;
              }
              if(savinglabl != ''){
                singleitem += `<div class="product-item__label-list label-list top">${savinglabl}</div>`;
              }              
                singleitem += `<div data-instant class="product-item__media_slider">
                  <a href="/products/${product.handle}"> 
                    <img src="${product.images[0].src}" loading="lazy" width="${product.images[0].width}" height="${product.images[0].height}" class="product-item-image" alt="${product.title}">
                  </a>                  
                </div>
                
                <div class="product-item__quick-form hidden-phone">
                  <button is="toggle-button" loader aria-controls="product-${product.id}-drawer" aria-expanded="false" class="button button--primary button--text button--full hidden-touch hidden-phone">${window.themeVariables.strings.quick_view}</button>
                  <button is="toggle-button" aria-controls="product-${product.id}-drawer" aria-expanded="false" class="product-item__quick-buy-button hidden-no-touch hidden-pocket">
                    <span class="visually-hidden">${window.themeVariables.strings.quick_view}</span>
                    ${window.themeVariables.settings.quickviewicon}
                  </button>
        
                  <button is="toggle-button" aria-controls="product-${product.id}-popover" aria-expanded="false" class="product-item__quick-buy-button hidden-tablet-and-up">
                    <span class="visually-hidden">${window.themeVariables.strings.quick_view}</span>
                    ${window.themeVariables.settings.quickviewicon}
                  </button>
                </div>
        
                <quick-buy-popover id="product-${product.id}-popover" href="/products/${product.handle}?view=quick-buy-popover" class="popover popover--quick-buy hidden-tablet-and-up"></quick-buy-popover>
                <quick-buy-drawer id="product-${product.id}-drawer" href="/products/${product.handle}?view=quick-buy-drawer" class="drawer drawer--large drawer--quick-buy hidden-phone"></quick-buy-drawer>
              </div>
            
              <div class="product-item__info">
                <div class="product-item-meta">
                    <a href="/products/${product.handle}" data-instant class="product-item-meta__title">${product.title}</a>
                    <div class="product-item-meta__price-list-container">
                      <div class="price-list price-list--centered">`;
                         if (parseInt(product.variants[0].price) < parseInt(product.variants[0].compare_at_price)) {
                            singleitem += `<span class="price price--highlight"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatCurrency(Math.floor(parseInt(product.variants[0].price)))}</span>`;
                            singleitem += `<span class="price price--compare"><span class="visually-hidden">${window.themeVariables.strings.productRegularPrice}</span>${formatCurrency(Math.floor(parseInt(product.variants[0].compare_at_price)))}</span>`;
                          } else {
                            singleitem += `<span class="price ${this.priceClass}"><span class="visually-hidden">${window.themeVariables.strings.productSalePrice}</span>${formatCurrency(Math.floor(parseInt(product.variants[0].price)))}</span>`;
                          }                        
                      singleitem += `</div>
                    </div>
                </div>
              </div>
              
            </product-item></div>`;
            itemsparts += singleitem;
            }
          });
          itemresults += `<div class="items_main_wp" data-itemtypeindex="${ind}">${itemsparts}</div>`;            
        });
        resulthtml += `<div class="search_result_items">${itemresults}</div><div class="selectionchange_btn_wp hidden-tablet-and-up"><a href="javascript:void(0)" class="scrolltotop_btn button button--primary">Change the selection</a></div>`;
        $('.search_widget_mainstep').hide();
        $('.search_widget_results .result_container').append(resulthtml);
        $('.search_widget_results').show();
        _this.removeAttribute("disabled", "disabled");
        _this.removeAttribute("aria-busy", "true");  
        if($(window).width() < 740){
          const scrollableContent = $('.search_widget_popup .popup_content .result_container');
          const stickyElement = scrollableContent.find('.result_main_image');
          const stickyOriginalOffset = stickyElement.offset().top; // Get initial offset
        
          scrollableContent.on('scroll', function () {
            const scrollableOffset = $(this).offset().top; // Get scrollable area offset
            const scrollableScrollTop = $(this).scrollTop(); // Get current scroll position;
            const elementOffset = (stickyOriginalOffset + stickyElement.outerHeight()) - scrollableOffset;
            if (scrollableScrollTop > elementOffset) {
              $(this).find('.selectionchange_btn_wp').addClass('active')
            } else {
              $(this).find('.selectionchange_btn_wp').removeClass('active')
            }
          });    
        }
      });
    };
    reader.readAsDataURL(file);
          
  });

  $('body').on('click','.search_widget_popup .result_container .selectionchange_btn_wp .scrolltotop_btn', function(){  
    $('.search_widget_popup .popup_content .result_container').animate({ scrollTop: 0 });
  });
  
  $('body').on('click','.search_widget_popup .result_main_image .centermarker', function(){  
    $(this).closest('.result_main_image').find('.centermarker').removeClass('active');
    $(this).addClass('active');    
    $(this).closest('.search_widget_results').find('.search_result_items .items_main_wp').hide();
    $(this).closest('.search_widget_results').find('.search_result_items .items_main_wp[data-itemtypeindex="'+$(this).attr('data-pointindex')+'"]').show();
  });

  $('body').on('click','.search_widget_popup .btn_close_popup', function(){  
    $(this).closest('.search_widget_popup').removeClass('active');
    $('html').removeClass('lock-all');    
    $('.search_widget_popup .search_widget_results').hide();
    $('.search_widget_mainstep').show();
    $('.search_widget_popup .search_widget_results .result_container').html('');
    $('.search_widget_popup #file-upload').val('');
    $('.search_widget_popup #file-name-display').html('');
  });
  
  $('body').on('click','.search_widget_popup .new-customsearch', function(){  
    $('.search_widget_popup .search_widget_results').hide();
    $('.search_widget_mainstep').show();
    $('.search_widget_popup .search_widget_results .result_container').html('');
    $('.search_widget_popup #file-upload').val('');
    $('.search_widget_popup #file-name-display').html('');
  });
  
  $('body').on('click','#custom_search_widget', function(){  
    $('.search_widget_popup').addClass('active');
    $('html').addClass('lock-all');
  });  

  //set cookie
  function setCookie(name, value, days) {
      var d = new Date;
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  
  $('body').on('click','.category_selection .page_link', function(){
    if($(this).attr('data-gender') == 'men'){      
      setCookie('genderselected','men',1);
    }else{
      setCookie('genderselected','women',1);
    }
  });

  //get cookie
  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }

  if($('body').hasClass('template--search')){
    if(getCookie('genderselected') == 'men'){
      $('.category_selection .page_link').removeClass('active');
      $('.category_selection .page_link[data-gender="men"]').addClass('active');
      $('.gender_men').removeAttr('hidden');
      $('a[href^="/"]').each(function(){
        $(this).attr("href", '/pages/men'); // Set herf value         
      });
    }else{
      $('.category_selection .page_link').removeClass('active');
      $('.category_selection .page_link[data-gender="women"]').addClass('active');
      $('.gender_women').removeAttr('hidden');
    } 
  }  

  $(document).on("click",".active_offers_wrappee .promo-container .copy_code",function(){
    var temp = $("<input>");
    $("body").append(temp);
    temp.val($(this).attr('data-discountcode')).select();
    document.execCommand("copy");
    temp.remove();
    var _this = this;
    $(_this).find("span").text('copied');
    setTimeout(function(){
      $(_this).find("span").text('copy');
    },1000);
  });  

  if($('.scrollable_recommandation').length > 0){
   $(window).scroll(function() {
     var hT = $('.scrollable_recommandation').offset().top,
         hH = $('.scrollable_recommandation').outerHeight() - 200,
         wH = $(window).height(),
         wS = $(this).scrollTop();
     if (wS > (hT+hH-wH)){
      // $('body .scrollable_recommandation .product-list .loading').remove();
       if($('body .scrollable_recommandation .product-list .product-item.hashide').length > 0){
        $('body .scrollable_recommandation .product-list .product-item.hashide:lt(8)').removeClass('hashide');
       }    
     }
    }); 
  }  

  if($('.timermain').length > 0){
    var endtime = $('#timermain').attr('data-timer');
    // Set the date we're counting down to
    var countDownDate = new Date(endtime).getTime();
    var hascnnt = 0;
    // Update the count down every 1 second
    var x = setInterval(function() {
    
      // Get today's date and time
      var now = new Date().getTime();
        
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
        
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));   
      if(days < 10){
        days = '0'+days; 
      } 
      var dayshtml = '';
      if(days > 0){
        dayshtml = '<span class="value">'+days+'<span class="extratext">Days</span></span><span> : </span>';
      }      
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));      
      if(hours < 10){
        hours = '0'+hours; 
      } 
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      if(minutes < 10){
        minutes = '0'+minutes; 
      } 
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      if(seconds < 10){
        seconds = '0'+seconds; 
      } 
        
      // Output the result in an element with id="demo"
      $('.timermain').html(dayshtml+'<span class="value">'+hours+'<span class="extratext">Hours</span></span><span> : </span><span class="value">'+minutes+'<span class="extratext">Minutes</span></span><span> : </span><span class="value">'+seconds+'<span class="extratext">Seconds</span></span>');
        
      // If the count down is over, write some text 
      if (distance < 0) {
        clearInterval(x);        
        if($('.timermain').closest('announcement-bar-item').length > 0){
         const yourAnnouncementBarInstance = document.querySelector('announcement-bar');
         yourAnnouncementBarInstance.removeSlide($('.timermain').closest('announcement-bar-item').index());
        }    
        
        $('.timermain').html('Time Expired!');
      }else{        
        if(hascnnt == 0 && $('.timermain').closest('announcement-bar-item').index() == 0){
          if($('.timermain').closest('announcement-bar-item').length > 0){
           $('.timermain').closest('announcement-bar-item').removeAttr('hidden'); 
          }        
          hascnnt += 1; 
        }        
      }
    }, 1000);
  }

  if($('.template--collection .custom_filter_wp:not(.size_filtermain)').length > 0){
   var eleheight = $('.template--collection .custom_filter_wp:not(.size_filtermain)').outerHeight();  
    var headerheight = $('.header').outerHeight();
    if($(window).width() < 1000){
      headerheight += $('#mobile-facet-toolbar').outerHeight();
    }
    var elementTop = $('.template--collection .custom_filter_wp:not(.size_filtermain)').offset().top  - headerheight - 15;
    var viewportTop = $(window).scrollTop();
    if (viewportTop >= elementTop) {
      $('.template--collection .custom_filter_wp:not(.size_filtermain)').addClass('fixed').css('top',headerheight+'px');
      $('.template--collection #facet-main').css('padding-top',eleheight+'px');
    }else {
      $('.template--collection .custom_filter_wp:not(.size_filtermain)').removeClass('fixed').css('top','0px');
      $('.template--collection #facet-main').css('padding-top','0px');
    }
    
    $(window).scroll(function(){        
      var viewportTop = $(window).scrollTop();
      if (viewportTop >= elementTop) {
        $('.template--collection .custom_filter_wp:not(.size_filtermain)').addClass('fixed').css('top',headerheight+'px');
        $('.template--collection #facet-main').css('padding-top',eleheight+'px');
      }else {
        $('.template--collection .custom_filter_wp:not(.size_filtermain)').removeClass('fixed').css('top','0px');
        $('.template--collection #facet-main').css('padding-top','0px');
      }
    }); 
  }      

  
  $('.two-images_grid').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: false,
    responsive: [
      {
          breakpoint: 741,
          settings: 'unslick'
      }
    ]
  });

  $(".iwtc-slider").slick({
      dots: false,
      arrows:true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
          breakpoint: 999,
          settings: 'unslick'
      }
    ]
  });

  $(".sbc_grid_slider").slick({
    dots: false,
    arrows:true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 3
        }
      },
      {
          breakpoint: 741,
          settings: 'unslick'
      }
    ]
  });
  
  $(".blog-posts-row").slick({
      dots: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });

  $(".fcs-slider:not(.drag_false)").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 740,
      settings: "unslick"
    }
  ]
  });  
  $(".fcs-slider.drag_false").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    draggable: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: "unslick"
      }
    ]
  });  
  
  $(window).on('resize', function() {
      $('.two-images_grid').slick('resize');
  });

  $('body').on('click','.custom_filter_wp .fill_values input[type="checkbox"],.instock_chip .checkbox-container input[type="checkbox"]',function(e){
    e.preventDefault();
    var _this = $(this);    
    var href = $(this).attr('name');
    var val = $(this).attr('value');
    if(val != undefined && val != ''){
      if(val.indexOf(' ') >= 0){
        val = val.replaceAll(' ','+');
      }
      var currentURL = window.location.href;
      var finalVAL = href+'='+val;
      var is_current = false;
      var without_cur = [];
      var params = {};
      var parser = document.createElement('a');
      parser.href = window.location.href;
      var query = parser.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');        
        if(encodeURI(href) == pair[0] && val == pair[1]){
          is_current = true;
        }else{
          if(_this.closest('.custom_filter_wp').hasClass('single_value')){
            if(encodeURI(href) == pair[0]){
             without_cur.push(pair[0] + '=' + val);    
            }else{
             without_cur.push(pair[0] + '=' + pair[1]);    
            }
          }else{
           without_cur.push(pair[0] + '=' + pair[1]); 
          }          
        }
      }
      if(is_current){               
        currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
        if(without_cur.length > 0){
          currentURL = currentURL + '?' +without_cur.join('&')
        }else{              
          currentURL = currentURL;
        }            
      }else{   
        if(_this.closest('.custom_filter_wp').hasClass('single_value') && currentURL.indexOf(href) > -1){
          var newurl = [];
          currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');        
            if(encodeURI(href) == pair[0]){
              newurl.push(finalVAL);
            }else{                
              newurl.push(pair[0] + '=' + pair[1]);                 
            }
          }
          if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + newurl.join('&');
          }else{
            currentURL = currentURL + '?' + newurl.join('&');
          }
        }else{
         if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + finalVAL;
          }else{
            currentURL = currentURL + '?' + finalVAL;
          }  
        }        
      }  
      if(_this.closest('#custom-size-filter').length > 0){
        document.querySelector('#custom-size-filter').open = false;
      }
      this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
        bubbles: true,
        detail: {
          url: currentURL.toString()
        }
      }));
    }
  });

  $('body').on('click', '.share_button_opener .share_button_main', function(){
    $(this).closest('.product-form').find('.product-meta__aside').slideToggle();
  });

  $('body').on('click','.Frequently_bought_together .fbt-submit', function(){
    var submitButtons = $(this);    
    submitButtons.attr("disabled", "disabled");
    submitButtons.attr("aria-busy", "true");
    var vid = $(this).attr('data-vid');
    submitButtons.closest('.item_details').find('.add_err_msg').remove();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: vid,
      },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);     
        submitButtons.after('<p class="add_err_msg">'+response.description+'</p>');
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy"); 
        setTimeout(function(){
          submitButtons.closest('.item_details').find('.add_err_msg').remove();
        },5000);
      },
      success: function(data){
        submitButtons.removeAttr("disabled");
        submitButtons.removeAttr("aria-busy");        
        fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
          const cartContent = await response2.json();
          document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
            bubbles: true,
            detail: {
              cart: cartContent
            }
          }));
          // cartContent["sections"] = responseJson["sections"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: true
            }
          }));
          // document.getElementById('mini-cart').open = true;
        });
      }
    });
  });

  $('body').on('click','.model_stats .map_selector a:not(.active)',function(){
    if($(this).hasClass('cm')){
      $(this).closest('.model_stats').find('.content_wp ul li').each(function(i, e){
        var new_val = parseInt($(this).find('p').text()) * 2.54;
        new_val = new_val.toFixed(2);
        $(this).find('p').text(new_val);
      });
    }else{
      $(this).closest('.model_stats').find('.content_wp ul li').each(function(i, e){
        $(this).find('p').text($(this).find('p').attr('data-defaultvalue'));
      });
    }
    $(this).closest('.model_stats').find('a').removeClass('active');
    $(this).addClass('active');
  });

  $("body").on("click",'.specification_details .see_more', function () {
    var txt = $(".specification_details .specification_details_content ul .hidden").is(':visible') ? 'SEE MORE' : 'SEE LESS';
    $(".specification_details .see_more").text(txt);
    $(this).closest('.specification_details_content').find('ul .hidden').slideToggle(200);
  });


  $('body').on('click','a[href="#quiz_popup"]', function(e){
    e.preventDefault();
    var _this = $(this);     
    if(_this.attr('data-gender') == 'male'){        
       $.get("/collections/mens-jean-collection?view=filter_use", function( data ) {
        $('#quiz_main_wp').html($(data).find('.get_data_main').html());      
        setTimeout(function(){          
          $('body').addClass('hide-scrollbar').find('.quiz_popup').addClass('active');  
        },500);      
      }); 
    }else{        
       $.get("/collections/shop-womens-jeans?view=filter_use", function( data ) {
        $('#quiz_main_wp').html($(data).find('.get_data_main').html());      
        setTimeout(function(){                     
          $('body').addClass('hide-scrollbar').find('.quiz_popup').addClass('active');  
        },500);      
       });
    }            
  });
  
  $('body').on('click','.quiz_popup .close_popup', function(e){
    e.preventDefault();
    $('.quiz_popup').removeClass('active');  
    $('.flex-main').removeClass('current_active');
    $('.flex-main[data-index="1"]').addClass('current_active');
    $('body').removeClass('hide-scrollbar');
  });

  $('body').on('click','.popup_footer .next-prev-buttons a', function(e){
    e.preventDefault();
    if($(this).hasClass('disable')){
      return;
    }
    if($(this).hasClass('next_arrow')){
      var pageindex = parseInt($(this).closest('.flex-main').attr('data-index')) + 1;
    }else{
      var pageindex = parseInt($(this).closest('.flex-main').attr('data-index')) - 1;
    }
    $('.quiz_popup .quiz_content_steps .flex-main').removeClass('current_active');
    $('.quiz_popup .quiz_content_steps .flex-main[data-index="'+pageindex+'"]').addClass('current_active');
  });

  $('body').on('click','.quiz_popup .filter_submit_btn', function(e){
    e.preventDefault();
    var link_data = [];
    var link = $(this).attr('data-url');
    $(this).closest('.quiz_content_steps').find('.flex-main').each(function(i,e){
      var name = $(e).find('[type="radio"]:checked').attr('name');
      var value = $(e).find('[type="radio"]:checked').val();
      link_data.push(name+'='+value);
    });
    window.location.href = link+'?'+link_data.join('&');
  });

  $('body').on('click','[href="#gender_selection"]', function(e){
    e.preventDefault();
    $('#gender_selection_popup').attr('open','');
  });

  $('body').on('click','.sizechart_table .table_head .size_toggle', function(e){
    e.preventDefault();
    $('.size_toggle').removeClass('active');
    $(this).addClass('active');
    var selector = $(this).attr('data-value');
    $(this).closest('.sizechart_table').find('.table-wrapper .tr').each(function(i, main){
      $(main).find('.td').each(function(i,e){
        console.log();
        if(selector == 'in'){
          var mainval = parseInt($(this).text()) / 2.54;
          $(this).text(mainval.toFixed(2));
        }else{
          $(this).text($(this).attr('data-value'));
        }
      });
    });    
  });
   
   $('a[href^="/collections/"],a[href^="https://freakins.com/collections/"]').each(function(){
    var oldUrl = $(this).attr("href"); // Get current url
     if(oldUrl.indexOf('?') > -1){
      // var url = oldUrl+'&filter.v.availability=1'; 
     }else{
      var url = oldUrl+'?filter.v.availability=1';
      var newUrl = oldUrl.replace(oldUrl, url); // Create new url
      $(this).attr("href", newUrl); // Set herf value
     }         
  });

  if($(window).width() < 768){
     $('.featured-collections').find('.scroller_sib').removeClass('scroller').find('.product-list__inner').removeClass('product-list__inner--scroller').removeClass('hide-scrollbar');
  }

  $('body').on('click','.featured-collection-secondary .tabs-nav__item-list .tabs-nav__item', function(){
    $(this).closest('.tabs-nav__item-list').find('.tabs-nav__item').attr('aria-expanded', false);
    $(this).attr('aria-expanded', true);
    $(this).closest('.featured-collection-secondary').find('.tabbing_content_slides .tab_content_main').removeClass('active');
    var to = $(this).closest('.featured-collection-secondary').find('.tab_content_main[data-tab="'+ $(this).attr('data-aria') +'"]');    
    to.addClass('active');     
  });

  $("body").on('click','.product-tab_link',function () {
    var activeTab = $(this).attr("href");
    if ($(this).hasClass('active')) {
      console.log('has');
      $(".product-tab_link").removeClass("active");
      $(".product-tab_content-block").hide();
    } else {
      $(".product-tab_link").removeClass("active");
      $(".product-tab_content-block").hide();
      $(this).toggleClass("active");
      $(activeTab).fadeToggle();
      console.log('no');
    }
    
    return false;
  });

  function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: data
    }));
  }

  $('body').on('click', '.product-form__option-selector .block-swatch input[type="radio"] ', function(e){
    var $currentSelector = $(this).closest('.product-form__option-selector');
    var clicked = $currentSelector.attr('data-clicked') || 0;
    console.log(clicked);
    if(clicked == 0){
      var masterselector = document.getElementById($(this).closest('product-variants').attr("form-id")).id;
      if($(this).closest('.drawer__content').length > 0){
        var productDataScript = $(this).closest('.drawer__content').find('script[type="application/json"][data-productjson]')[0];
      }else{
        var productDataScript = document.querySelector('script[type="application/json"][data-productjson]');  
      }
      
      if (productDataScript) {
        console.log(productDataScript);
        if($(this).closest('.drawer__content').length > 0){
          var productData = JSON.parse($(productDataScript).text());
        }else{        
          var productData = JSON.parse(productDataScript.textContent);
        }
          
        const variantId = parseInt($(this).attr('data-vid')); // Replace this with the actual variant ID you want to match
        const selectedVariant = productData.variants.filter(variant => {
            return variant.id === variantId; // Ensure data types match
        })?.[0];       
        $(this).closest('.product-form').find('[data-product-add-to-cart-button]').removeClass('selectasize');
        triggerEvent(masterselector, "variant:changed", { variant: selectedVariant });
      } else {
          console.log("No JSON-LD product data found.");
      } 
        $currentSelector.attr('data-clicked', 1);      
    }          
  });

  document.addEventListener('variant:changed', function(event) {
    let variant = event.detail.variant; // Gives you access to the whole variant details
    let form = event.target;
    if($(window).width() < 999){
     if(!$('.sticky-container').hasClass('formvisible')){
        $('.sticky-container').addClass('forceatc');
      } 
    }    
  });
  if($(window).width() < 999){    
    $("body").on("click",'#original-selected .block-swatch__item', function () {
      var _this = $(this);
      $("#original-selected .block-swatch__item").removeClass("active");    
      $(this).addClass("active");    
    });
  
    $("body").on("click",".sticky-container .sticky-addtobad", function () {
      $(this).closest('.sticky-container').addClass('formvisible');  
    });
    
    $(".sticky-container .sticky-close,.sticky-container .sticky-overlay").click(function () {
      if($(this).closest('.popup_main_content').find('.block-swatch__item.active').length > 0){
        $(this).closest('.sticky-container').addClass('forceatc');
      }
      $(this).closest('.sticky-container').removeClass('formvisible');
    });
  }
  
});

